import(/* webpackMode: "eager" */ "/app/frontend/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/frontend/src/components/common/CookieConsent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["I18nProvider"] */ "/app/frontend/src/lib/i18n-context.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/leaflet/dist/leaflet.css");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/app/node_modules/react-hot-toast/dist/index.mjs");
